
// src/components/AddCategoryModal.jsx
import React, { useState } from "react";
import { createCategory } from "../lib/servicesApi";

const AddCategoryModal = ({ show, onClose, onCreated }) => {
    const [form, setForm] = useState({ key: "", label: "", active: true });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    if (!show) return null;

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        const key = form.key.trim();
        const label = form.label.trim();

        if (!key) {
            setError(new Error("Category key (slug) is required"));
            return;
        }

        setSaving(true);
        try {
            await createCategory({ key, label: label || key, active: form.active });
            onCreated?.(key);
            setForm({ key: "", label: "", active: true });
            onClose?.();
        } catch (err) {
            setError(err);
        } finally {
            setSaving(false);
        }
    };

    // Wrap multiple siblings in a Fragment to avoid multiple roots.
    return (
        <>
            <div className="modal d-block" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content shadow">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Category</h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={onClose}
                            />
                        </div>

                        <form onSubmit={onSubmit}>
                            <div className="modal-body">
                                {error && <div className="alert alert-danger">{error.message}</div>}

                                <div className="mb-3">
                                    <label htmlFor="cat-key" className="form-label">
                                        Key (slug)
                                    </label>
                                    <input
                                        id="cat-key"
                                        name="key"
                                        className="form-control"
                                        placeholder="e.g., cleaning"
                                        value={form.key}
                                        onChange={onChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="cat-label" className="form-label">
                                        Label (display)
                                    </label>
                                    <input
                                        id="cat-label"
                                        name="label"
                                        className="form-control"
                                        placeholder="e.g., Cleaning"
                                        value={form.label}
                                        onChange={onChange}
                                    />
                                </div>

                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="cat-active"
                                        name="active"
                                        checked={form.active}
                                        onChange={onChange}
                                    />
                                    <label className="form-check-label" htmlFor="cat-active">
                                        Active
                                    </label>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={onClose}
                                    disabled={saving}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={saving}>
                                    {saving ? "Saving..." : "Add Category"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Backdrop */}
            <div className="modal-backdrop fade show" onClick={onClose} />
        </>
    );
};

export default AddCategoryModal;